module.exports = __webpack_public_path__ + "img/LUB00391.a799bc50.png";